// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2TBcQ","alertIcon":"ConfirmModal_alertIcon__kjjg0"};